import { createSlice } from "@reduxjs/toolkit";
import { emitCommand } from "../socket";

const PeerConnectionsSlice = createSlice({
    name: "peerConnections",
    initialState: {
        peerConnections: []
    },
    reducers: {
        setPeerConnections: (state, action) => {
            state.peerConnections = action.payload;
        }
    }
});

// Signalling rows arrive through the `peer:update` broadcast, so these commands
// only need to fire — the store is updated by the push that follows.
const command = (event, payload) => emitCommand(event, payload).catch(() => { /* signalling is best effort */ });

export function createCall(gameId) {
    return () => {
        command('peer:create', { gameId });
    }
}

export function addFromConnector(connectorId, connector) {
    return () => {
        command('peer:addFrom', { connectionId: connectorId, fromConnectionDet: connector });
    }
}

export function addToConnector(connectorId, connector) {
    return () => {
        command('peer:addTo', { connectionId: connectorId, toConnectionDet: connector });
    }
}

export function destroyConnection(connectorId) {
    return () => {
        command('peer:destroy', { connectionId: connectorId });
    }
}

export const { setPeerConnections } = PeerConnectionsSlice.actions;

export const peerConnectionsSelector = (state) => state.peerConnections.peerConnections;

export default PeerConnectionsSlice.reducer;
